import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, DatasourceErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { DatasourceContentType } from '../../ts/models/ContentTypes';
import { IDataSourceBase } from '../../ts/models/IDataSourceInfo';
import { IError } from '../../httpClient/serverApi/types/IError';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';

export namespace DataSourceErrors {
  export function errorDetailsFor(datasourceErrorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: datasourceErrorItem.item.name,
      itemUrl:
        datasourceErrorItem.error.code === CommonErrorCode.DatasourceNotFound
        || datasourceErrorItem.error.code === CommonErrorCode.DataConnectionNotFound
          ? null
          : ContentUrlForItem(datasourceErrorItem.item, DatasourceContentType),
      errorMessage: this.errorMessageFor(datasourceErrorItem.error, datasourceErrorItem.item.name)
    };
  }

  export function errorMessageFor(error: IError, datasourceName: string = '') {

    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
      case CommonErrorCode.DataConnectionNotFound:
        return Messages.errorDatasourceNotFound({DATASOURCE_NAME: L10n.elideIfLong(datasourceName)});
      case DatasourceErrorCode.DatasourceChangeOwnerDisabled:
        return Messages.errorDatasourceChangeOwnerDisabled();

      // Permissions errors
      // TODO: Do we want specific error messages for each of these cases?
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDatasource:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnDestinationProject:
      case DatasourceErrorCode.DatasourceMoveInsufficientPermissionsOnSourceProject:
        return Messages.errorDatasourceMoveInsufficientPermissions();
      case DatasourceErrorCode.DatasourceWithSameNameInDestinationProject:
        return Messages.errorDatasourceWithSameNameInDestinationProject();
      case CommonErrorCode.CallingUserInsufficientPermissions:
          return Messages.errorDatasourceInsufficientPermissions();

      default:
        return Messages.errorUnknown();
    }
  }
}
